import { downloadFuneralMemo } from "../../../api/pro/eventReq";
import useAuth from "../../../hooks/useAuth";
import { useParams } from "react-router-dom";

export default function ViewDeceasedSolutions({ deceasedInfos }) {
    const { auth } = useAuth();
    const token = auth?.token;
    const { id } = useParams();
    const BASE_URL = process.env.REACT_APP_OEF_URL;


    const handleDownloadMemo = (e) => {
        e.preventDefault();
        downloadFuneralMemo(token, id)
            .then(response => {
                if (response instanceof Blob) {
                    // Si c'est du HTML, c'est l'URL de téléchargement du PDF
                    if (response.type === 'text/html') {
                        response.text().then(downloadUrl => {
                            const pdfLink = document.createElement('a');
                            pdfLink.href = downloadUrl;
                            pdfLink.target = '_blank';
                            pdfLink.setAttribute('download', `memo_${deceasedInfos?.lastName}-${deceasedInfos?.firstName}-${deceasedInfos?.deathDate}.pdf`);
                            document.body.appendChild(pdfLink);
                            pdfLink.click();
                            document.body.removeChild(pdfLink);
                        })
                    }
                    // Si c'est directement un PDF, le télécharger
                    else if (response.type === 'application/pdf') {
                        const blob = new Blob([response], { type: 'application/pdf' });
                        const blobUrl = URL.createObjectURL(blob);
                        const pdfLink = document.createElement('a');
                        pdfLink.href = blobUrl;
                        pdfLink.target = '_blank';
                        pdfLink.setAttribute('download', `memo_${deceasedInfos?.lastName}-${deceasedInfos?.firstName}-${deceasedInfos?.deathDate}.pdf`);
                        document.body.appendChild(pdfLink);
                        pdfLink.click();
                        document.body.removeChild(pdfLink);
                        URL.revokeObjectURL(blobUrl);
                    }
                }
            })
            .catch(error => {
                console.error('Erreur lors du téléchargement du mémo:', error);
            });
    }

    return (
        <>
            <div className="flex-buttons solutions">
                {deceasedInfos?.isListed &&
                    <a target="_blank"  href={`${BASE_URL}/fiche-avis-de-deces/${deceasedInfos?.id}-${deceasedInfos?.firstName}-${deceasedInfos?.lastName}/`}><i className="fa fa-eye"/><span>Voir la page du défunt</span></a>
                }
                <a onClick={handleDownloadMemo} target="_blank" className="clickable-link"><i className="fa fa-file-pdf"/><span>Télécharger le Mémo Obsèques</span></a>
            </div>
            <div className="flex containers">
                <div className="flex action-box-container">
                    <div className="action-box">
                        <h3>Condoléances</h3>
                        <div className="flex box-content">
                            <a href={`${deceasedInfos?.id}/condoleances/moderer`}><i className="fa fa-check-circle"/>Modérer</a>
                            {deceasedInfos?.isListed &&
                                <a href={`${BASE_URL}/condoleances/${deceasedInfos?.id}-${deceasedInfos?.firstName}-${deceasedInfos?.lastName}/`} target="_blank"><i className="fa fa-eye"/>Voir les condoléances</a>
                            }
                        </div>
                    </div>
                    <div className="action-box">
                        <h3>Courriers après-décès</h3>
                        <div className="flex box-content">
                            <a href={`${deceasedInfos?.id}/courriers-apres-deces/express`} className="express-link"><i className="fa fa-paper-plane"/>Express</a>
                            <a href="https://docs.google.com/forms/d/e/1FAIpQLSdMioiNOXOZNAdXZ6d5lgKOuVjXtOtY7HLLkCnItMiqs4VD9A/viewform?pli=1" target="_blank"><i className="fa fa-calendar"/>Rendez-vous avec un expert</a>
                        </div>
                    </div>
                </div>
                <div className="flex action-box-container">
                    <div className="action-box third">
                        <h3>Faire-part & Avis de décès</h3>
                        <div className="flex box-content">
                            <a href={`${deceasedInfos?.id}/faire-part-avis-de-deces/modifier`} className="modify-link"><i className="fa fa-pen-to-square"/>Modifier</a>
                            <a><i className="fa fa-eye"/>Aperçu</a>
                            <a href={`${deceasedInfos?.id}/faire-part-avis-de-deces/fichier`} target="_blank"><i className="fa fa-file-pdf"/>Télécharger</a>
                        </div>
                    </div>
                    <div className="action-box">
                        <h3>Faire-part & Remerciements</h3>
                        <div className="flex box-content fourth">
                            <a href={`${deceasedInfos?.id}/faire-part-remerciement/modifier`} className="modify-link"><i className="fa fa-pen-to-square"/>Modifier</a>
                            <a><i className="fa fa-eye"/>Aperçu</a>
                            <a href={`${deceasedInfos?.id}/faire-part-remerciement/fichier`} target="_blank"><i className="fa fa-file-pdf"/>Télécharger</a>
                        </div>
                    </div>
                </div>
            </div>
        </>

    )
}